export const queryKeys = {
  loans: "loans",
  user: "user",
  users: "users",
  branch: "branch",
  loanTypes: "loanTypes",
  checklist: "checklist",
};
